import React from "react";
import Home from "./components/page/Home";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import PageStat from "./components/page/PageStat";
import Error404 from "./components/Error404";
import Header from "./components/Header";

function App() {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pokemon/*" element={<Header />}></Route>
          <Route path="/pokemon/:id" element={<PageStat />}>
          </Route>
          <Route path="*" element={<Error404 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
